module.exports = __webpack_public_path__ + "assets/icon-tree.anim.3e12ffc6.svg";